import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

const FilterButton = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 2px solid transparent;
  cursor: pointer;

  &.active {
    border-bottom-color: ${theme.colors.AccentNaplesYellow};
    cursor: auto;
  }
`;

export default FilterButton;
